import { render, staticRenderFns } from "./AccountantSettlements.vue?vue&type=template&id=7774283b&scoped=true"
import script from "./AccountantSettlements.vue?vue&type=script&lang=js"
export * from "./AccountantSettlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7774283b",
  null
  
)

export default component.exports